import $ from 'jquery'

function addParam(url, param, value) {
  param = encodeURIComponent(param)
  const a = document.createElement('a')
  param += value ? '=' + encodeURIComponent(value) : ''
  a.href = url
  a.search += (a.search ? '&' : '') + param
  return a.href
}

export function buildUrl(base, value) {
  base = base.replace(/\/ledgers\/[0-9]+/g, `/ledgers/${value}`)
  if (base.match(/current_ledger_id=[0-9]+/)) {
    return base.replace(
      /current_ledger_id=[0-9]+/g,
      `current_ledger_id=${value}`
    )
  } else {
    return addParam(base, 'current_ledger_id', value)
  }
}

$(document).on('click', "[data-behaviour~='set-current-ledger']", (e) => {
  const ledgerId = $(e.target).data('ledgerId')

  if (ledgerId) {
    Turbolinks.visit(buildUrl(window.location.href, ledgerId))
  }
})
